import { BaseValidationRule, IValidateable } from '@aurelia/validation';

import { isValidNumber } from 'libphonenumber-js';

export class ValidPhoneNumberPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super();
  }

  public execute(value: any, _object?: IValidateable): boolean {
    return typeof value !== 'undefined' && value !== null && isValidNumber(value, 'AU')
  }
}
